import axios from 'axios';
import { API_URL } from '@/config';
import { axios2 } from '@/lib/axios';

export type ResendOtp = {
  email: string;
};

export const resendOtp = (data: ResendOtp) => {
  return axios2.post(`customer-api/register-resend`, data);
};
